<template>
  <header
    ref="headerEl"
    class="fixed z-30 flex w-full flex-col bg-stone-200 py-3 text-center sm:py-4 dark:bg-gray-800 dark:text-gray-300"
  >
    <div class="mx-auto w-full max-w-3xl px-4 sm:px-8">
      <RouterLink
        to="/"
        class="text-lg font-bold hover:underline hover:underline-offset-2 sm:text-2xl"
        >Oepke Noordmans</RouterLink
      >
    </div>

    <nav
      class="overflow-hidden sm:h-7"
      :class="{ 'h-0': isCollapsed, 'h-5': !isCollapsed }"
    >
      <ul
        class="flex justify-center gap-1 text-sm opacity-75 sm:gap-2 sm:text-lg after:[&>li]:pl-1 after:[&>li]:content-['-'] last:[&>li]:pl-0 last:after:[&>li]:content-none sm:after:[&>li]:pl-2 [&_.router-link-active]:underline [&_a]:underline-offset-2 hover:[&_a]:underline"
      >
        <li>
          <RouterLink :to="{ name: 'biography' }">Over</RouterLink>
        </li>
        <li><RouterLink :to="{ name: 'works' }">Werk</RouterLink></li>
        <li>
          <RouterLink :to="{ name: 'foundation' }">Stichting</RouterLink>
        </li>
        <li>
          <RouterLink :to="{ name: 'donation' }">Doneer</RouterLink>
        </li>
      </ul>
    </nav>
  </header>
</template>

<script setup lang="ts">
  import { onMounted, onUnmounted, ref, useTemplateRef, watch } from 'vue'

  const emit = defineEmits(['update:height'])
  const props = defineProps<{ scrollY: number }>()
  const headerEl = useTemplateRef<HTMLDivElement>('headerEl')
  const isCollapsed = ref(false)

  const emitHeight = () => {
    const height = headerEl.value?.offsetHeight
    emit('update:height', height)
  }

  watch(
    () => props.scrollY,
    (number) => {
      const offset = headerEl.value?.offsetHeight || 0
      isCollapsed.value = number > offset

      emitHeight()
    },
  )

  onMounted(() => {
    window.addEventListener('resize', emitHeight)
    emitHeight()
  })

  onUnmounted(() => {
    window.removeEventListener('resize', emitHeight)
  })
</script>
